module.exports = __webpack_public_path__ + "media/images/story/icon/cheers-icon-71590d2307a9ee80c2c867c26ad7263e.png";